import { render } from "./DetailsCompositionPage.vue?vue&type=template&id=2c4ad763&ts=true"
import script from "./DetailsCompositionPage.vue?vue&type=script&lang=ts"
export * from "./DetailsCompositionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__